import TextField from "../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../components/fields/file-input-field/FileInputField.vue";
import {
  tipoReprogramacaoEnum
} from "../../../../constants";
import {
  SnackBarModule
} from "../../../../modules/SnackBarModule";
import {
  ReprogramarFeriasService
} from "../../../../services/ReprogramarFeriasService";
import {
  SolicitarFeriasService
} from "../../../../services/SolicitarFeriasService";

import moment from "moment";

export default {
  name: "ReprogramarFerias",

  props: {
    selected: {
      required: true,
      default:[],
    },
 
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField,
  },

  data: () => ({
    form: {},
  
    loading: false,
  }),

  computed: {
    enumtipoReprogramacao() {
      return tipoReprogramacaoEnum;
    }
  },

  beforeMount() {
    this.initializeForm();
    this.getData();
  },

  methods: {
    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("id_tipo_reprogramacao_periodo", this.form.tipoReprogramacao);

        if(!this.verificarCampos()){
          formData.append("data_ini", moment(this.form.dataInicioNovoPeriodo).format("YYYY-MM-DD"));
          formData.append("data_fin", moment(this.form.dataFimNovoPeriodo).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDiasNovoPeriodo);

        }else{
          formData.append("data_ini", moment(this.form.dataInicioLicenca).format("YYYY-MM-DD"));
          formData.append("dias", this.form.numeroDiasCorridos);

        }
        this.sendForm(formData);
        return;
      }

    },

    verificarCampos(){
      return this.form.tipoReprogramacao != this.enumtipoReprogramacao.NORMAL && this.form.tipoReprogramacao != null
    },

    async sendForm(formData) {
      this.loading = true;
      const response = await ReprogramarFeriasService.salvarAlteracao(formData);
      this.$emit('on-confirm');
      if (response) {
        this.close();
      }
      this.loading = false;
    },

    async calculateDays() {
      if (this.form.dataInicioLicenca == null) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicioNovoPeriodo).format("YYYY-MM-DD"));
        formData.append("dias", this.form.numeroDiasNovoPeriodo);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFimNovoPeriodo = response.dataFim;
        this.form.numeroDiasNovoPeriodo = response.dias_uteis;
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    close() {
      this.clean();
      this.$emit("on-close");
    },

    clean() {
      this.initializeForm();
    },
   
    initializeForm() {
      this.form = {
        dataInicio: this.selected.dataIni,
        dataFim: this.selected.dataFin,
        numeroDias: this.selected.numeroDias,

        dataInicioNovoPeriodo: null,
        dataFimNovoPeriodo:    null,
        numeroDiasNovoPeriodo: null,

        tipoReprogramacao: null,
        dataInicioLicenca: null,
        anexo: null,
      }
    }
  },
};